import Vuetify, {
  VLayout, VApp, VAlert, VContainer, VFlex, VBtn, VCard, VNavigationDrawer, VList, VListTile, VListTileContent, VProgressCircular, VDivider, VDialog,
  VAutocomplete, VBadge, VAvatar, VListTileAction, VIcon, VListTileTitle, VToolbar, VToolbarTitle, VToolbarSideIcon, VSubheader, VMenu, VListTileAvatar,
  VTooltip, VFadeTransition, VContent, VCardTitle, VListTileSubTitle, VChip, VCheckbox, VListGroup, VBtnToggle, VCardText, VSwitch, VProgressLinear,
  VTextField, VCardActions, VCombobox, VSpeedDial, VTimePicker, VDatePicker, VSpacer, VSnackbar, VToolbarItems, VForm, VStepperContent, VStepperItems,
  VStepperStep, VStepper, VStepperHeader, VDataTable, VSelect, VRadioGroup, VRadio,
} from 'vuetify/lib';
import Vue from 'vue';
import * as directives from 'vuetify/es5/directives';
import StorageService from '../services/StorageService';
import '../../node_modules/vuetify/dist/vuetify.min.css';

const theme = JSON.parse(StorageService.get('theme')) || {
  primary: '#525d6d',
  secondary: '#e27824',
  accent: '#82B1FF',
  error: '#FF5252',
  info: '#2196F3',
  success: '#4CAF50',
  warning: '#FFC107',
};

Vue.use(Vuetify, {
  theme,
  components: {
    VContainer,
    VLayout,
    VAlert,
    VApp,
    VFlex,
    VBtn,
    VCard,
    VNavigationDrawer,
    VList,
    VListTile,
    VListTileContent,
    VProgressCircular,
    VDivider,
    VDialog,
    VAutocomplete,
    VBadge,
    VAvatar,
    VListTileAction,
    VIcon,
    VListTileTitle,
    VToolbar,
    VToolbarTitle,
    VToolbarSideIcon,
    VSubheader,
    VMenu,
    VListTileAvatar,
    VTooltip,
    VFadeTransition,
    VContent,
    VCardTitle,
    VListTileSubTitle,
    VChip,
    VCheckbox,
    VListGroup,
    VBtnToggle,
    VCardText,
    VSwitch,
    VProgressLinear,
    VTextField,
    VCardActions,
    VCombobox,
    VSpeedDial,
    VTimePicker,
    VDatePicker,
    VSpacer,
    VSnackbar,
    VToolbarItems,
    VForm,
    VStepperContent,
    VStepperItems,
    VStepperStep,
    VStepper,
    VStepperHeader,
    VDataTable,
    VSelect,
    VRadioGroup,
    VRadio,
  },
  iconfont: 'md',
  directives,
});
